import { Shadows } from '@mui/material';

import { croissantColors } from './croissantColors';

const shadows: Shadows = [
    'none', // elevantion:  0
    '0px 1px 4px rgba(0, 0, 0, 0.07)', // elevantion: 1
    '0px 1px 4px rgba(0, 0, 0, 0.07)', // elevantion:  2
    '0px 1px 4px rgba(0, 0, 0, 0.07)', // elevantion:  3
    '0px 1px 4px rgba(0, 0, 0, 0.07)', // elevantion:  4
    '0px 1px 6px -2px rgba(0, 0, 0, 0.35)', // elevantion:  5
    '0px 1px 6px -2px rgba(0, 0, 0, 0.35)', // elevantion:  6
    '0px 1px 6px -2px rgba(0, 0, 0, 0.35)', // elevantion:  7
    '0px 1px 6px -2px rgba(0, 0, 0, 0.35)', // elevantion:  8
    '0px 1px 5px rgba(0, 0, 0, 0.15)', // elevantion:  9
    '0px 1px 5px rgba(0, 0, 0, 0.15)', // elevantion:  10
    '0px 1px 5px rgba(0, 0, 0, 0.15)', // elevantion:  11
    '0px 1px 5px rgba(0, 0, 0, 0.15)', // elevantion:  12
    '0px 6px 12px rgba(0, 0, 0, 0.05)', // elevantion:  13
    '0px 6px 12px rgba(0, 0, 0, 0.05)', // elevantion:  14
    '0px 6px 12px rgba(0, 0, 0, 0.05)', // elevantion:  15
    '0px 6px 12px rgba(0, 0, 0, 0.05)', // elevantion:  16
    '0px 6px 20px -8px rgba(0, 0, 0, 0.25)', // elevantion:  17
    '0px 6px 20px -8px rgba(0, 0, 0, 0.25)', // elevantion:  18
    '0px 6px 20px -8px rgba(0, 0, 0, 0.25)', // elevantion:  19
    '0px 6px 20px -8px rgba(0, 0, 0, 0.25)', // elevantion:  20
    '0px 16px 64px -16px rgba(0, 0, 0, 0.3)', // elevantion:  21
    '0px 16px 64px -16px rgba(0, 0, 0, 0.3)', // elevantion:  22
    '0px 16px 64px -16px rgba(0, 0, 0, 0.3)', // elevantion:  23
    '0px 16px 64px 0px rgba(0, 0, 0, 0.3)', // elevantion:  24
];

/** Figma "Elevation/2" from the design system, which the MUI index scale above doesn't match. */
export const DS_ELEVATION_2 = '0px 1px 2px 0px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)';

/** Croissant "Elevation/card": a card resting on the page. */
export const CROISSANT_ELEVATION_CARD = `0px 2px 8px 1px ${croissantColors.shadow.base}`;

/** Croissant "Elevation/elevated card": a card lifted above the page, such as a popover or focus card. */
export const CROISSANT_ELEVATION_CARD_ELEVATED = `0px 8px 24px -4px ${croissantColors.shadow.strong}`;

/** Croissant "Elevation/badge float": a small surface floating just off what it explains, like a tooltip. */
export const CROISSANT_ELEVATION_BADGE_FLOAT = `0px 4px 10px -2px ${croissantColors.shadow.stronger}`;

/** Figma "Elevation/card". */
export const DS_ELEVATION_CARD = '0px 2px 4px 0px rgba(29, 29, 31, 0.06)';

export default shadows;
